import { SvgIcon } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';

const PaymentMethodVirementIcon = (props) => {
  const themeColor = useSelector((state) => state?.header?.themeColor);
  return (
    <SvgIcon {...props}>
      <svg
        width="135"
        height="87"
        viewBox="0 0 135 87"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <title>Virement</title>
        <rect
          x="1"
          y="1"
          width="132.692"
          height="85.2153"
          rx="4.86945"
          stroke={themeColor === 'light' ? '#4D4C4C' : '#fff'}
          strokeWidth="1.21736"
        />
        <g clipPath="url(#clip0)">
          <path
            d="M35.2391 37H37.7291L35.0391 48.56H30.7291L28.0391 37H30.5091L32.5091 46.52H33.2791L35.2391 37Z"
            fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
          />
          <path
            d="M39.2402 48.56V37H41.5802V48.56H39.2402Z"
            fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
          />
          <path
            d="M46.4496 44.69V48.56H44.0996V37H48.5896C51.3096 37 52.6696 38.27 52.6696 40.81C52.7128 41.4668 52.5776 42.123 52.2784 42.7092C51.9791 43.2954 51.5269 43.7898 50.9696 44.14L52.6196 48.56H50.0496L48.7296 44.69H46.4496ZM49.8596 42.17C50.1534 41.7874 50.299 41.3115 50.2696 40.83C50.2965 40.3487 50.1432 39.8745 49.8396 39.5C49.68 39.3315 49.4853 39.2003 49.2692 39.1156C49.0532 39.0309 48.8212 38.9949 48.5896 39.01H46.4496V42.68H48.6196C48.8519 42.6986 49.0852 42.6621 49.3007 42.5735C49.5161 42.4849 49.7077 42.3466 49.8596 42.17V42.17Z"
            fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
          />
          <path
            d="M54.6406 48.56V37H62.1207V39H56.9907V41.7H61.1006V43.7H56.9907V46.47H62.1207V48.47L54.6406 48.56Z"
            fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
          />
          <path
            d="M64.0605 48.56V37H68.0605L70.0605 45.43L72.0605 37H76.0605V48.56H73.7105V39.62H73.4605L71.2005 48.05H68.8505L66.5905 39.62H66.3305V48.56H64.0605Z"
            fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
          />
          <path
            d="M78.6406 48.56V37H86.1207V39H80.9907V41.7H85.1006V43.7H80.9907V46.47H86.1207V48.47L78.6406 48.56Z"
            fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
          />
          <path
            d="M88.0605 48.56V37H92.0605L94.8505 46.52H95.0205V37H97.3705V48.56H93.5106L90.6205 39.04H90.4505V48.56H88.0605Z"
            fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
          />
          <path
            d="M98.8105 39.08V37H107.311V39.08H104.251V48.56H101.901V39.08H98.8105Z"
            fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect
              x="28"
              y="37"
              width="79.3"
              height="11.56"
              fill={themeColor === 'light' ? '#4D4C4C' : '#fff'}
            />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  );
};

export default PaymentMethodVirementIcon;
